<template>
  <div class="FormSections m-3 disable-ske">
    <section v-for="(section, index) in config" :key="index">
      <h4>{{ section.title }}</h4>
      <p v-if="section.description">
        {{ section.description }}
      </p>

      <div class="fields">
        <span
          v-for="(field, index) in section.fields"
          class="field-wrapper"
          :class="{
            didntChange:
              field.default &&
              (vuelidate[section.id][field.id].$model === field.default ||
                !vuelidate[section.id][field.id].$model),
          }"
          :key="index"
        >
          <FormInput
            v-if="
              (section.type || field.type) === 'text' || !(section.type || field.type)
            "
            :value="vuelidate[section.id][field.id].$model"
            @input="(val) => setValue(section.id, field.id, val)"
            :ske="true"
            :vuelidate="vuelidate[section.id]"
            :placeholder="field.default"
            :fieldName="field.id"
            :id="field.id"
            :label="field.label"
          />
          <FormColorPicker
            v-else-if="(section.type || field.type) === 'color'"
            :value="vuelidate[section.id][field.id].$model || field.default"
            @input="(val) => setValue(section.id, field.id, val)"
            :ske="true"
            :id="field.id"
            :placeholder="field.default"
            :label="field.label"
            :vuelidate="vuelidate[section.id]"
            :fieldName="field.id"
          />
          <span class="field-id">{{ field.id }}</span>

          <span
            v-if="field.deletable === undefined || field.deletable"
            class="delete-icon"
            @click.prevent.stop="removeField(field.id, section)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </span>

        <div v-if="customAllowed && !isAdding && section.newField" class="d-flex align-items-end">
          <div class="add-new-field" @click="isAdding = section.id">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="ml-1">
              {{
                (section.newField && section.newField.newFieldPlaceholder) || "New field"
              }}
            </span>
          </div>
        </div>
      </div>
      <AddNewField
        v-if="customAllowed && isAdding === section.id"
        class="mt-3"
        v-bind="section.newField"
        @cancel="isAdding = false"
        @save="(field) => addNewField(section.fields, field)"
      />

      <div v-if="index < config.length - 1" class="divider"></div>
    </section>
  </div>
</template>

<script>
import FormInput from "../../../Inputs/FormInput.vue";
import FormColorPicker from "../../../Inputs/FormColorPicker.vue";
import AddNewField from "./AddNewField.vue";

export default {
  components: {
    FormInput,
    FormColorPicker,
    AddNewField,
  },
  props: ["config", "vuelidate", "custom-allowed"],
  data() {
    return {
      isAdding: false,
    };
  },
  methods: {
    removeField(fieldId, {fields, id}) {
      fields.splice(
        fields.findIndex((item) => item.id === fieldId),
        1
      );
      this.$emit("delete-field", {section: id, id: fieldId})
      this.$emit("updated");
    },
    addNewField(fields, field) {
      if (fields.find((item) => item.id === field.id))
        return this.$error("There is already another field with the same id.");
      fields.push(field);
      this.isAdding = false;
      this.$emit("updated");
    },
    setValue(sectionId, fieldId, val) {
      this.vuelidate[sectionId][fieldId].$model = val;
      this.$forceUpdate();
      this.$emit("updated");
    },
  },
};
</script>

<style>
.FormSections .form-group {
  margin-bottom: 0px;
}

.FormSections .didntChange .form-group {
  opacity: 0.85;
}

.FormSections .didntChange input {
  border-style: dashed;
}
</style>

<style scoped>
.field-id {
  opacity: 0.7;
  position: absolute;
  top: 0;
  right: 0;
}

svg {
  color: rgb(180, 180, 180);
}

.delete-icon {
  position: absolute;
  right: 0px;
  bottom: 0px;
  margin-bottom: 8px;
  margin-right: 6px;
  color: rgb(180, 180, 180);
  opacity: 0;
  transition-duration: 0.15s;
}

.divider {
  margin: 18px 0;
  margin-top: 26px;
  border-top: 1px solid var(--main-gray);
  opacity: 0.7;
}

.delete-icon:hover {
  color: var(--red);
}

.add-new-field {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  padding: 6.5px 8px;
  display: flex;
  flex-basis: 100%;
  align-items: center;
  cursor: pointer;
}

.field-wrapper {
  position: relative;
}

.field-wrapper:hover .delete-icon {
  opacity: 1;
}

.add-new-field:hover {
  background-color: rgba(248, 248, 248);
}

h4 {
  margin: 0;
  font-weight: 700;
  margin-bottom: 8px;
}

p {
  margin-bottom: 18px;
  font-size: 12px;
}

.fields {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;
  row-gap: 10px;
}
</style>

<style>
.FormSections input,
.FormSections textarea {
  border-radius: 4px;
}

.FormSections label {
  opacity: 0.98;
}
</style>
